import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Delivery structure',
  subtitle: 'Choose how orders are delivered (per location).',
  form: {
    delivery_mode: {
      label: 'Delivery Mode',
      placeholder: 'Select delivery mode',
      options: {
        [DeliveryMode.Internal]: 'Internal (own drivers)',
        [DeliveryMode.External]: 'External (third-party)',
      },
    },
  },
  buttons: {
    back: 'Back',
    next: 'Next',
    skip: 'Skip',
  },
  toasts: {
    error: 'Something went wrong. Please try again.',
  },
};
